<script setup lang="ts">
import type { CalendarBookingViewQuestionAnswersBookingFragment } from './CalendarBookingViewQuestionAnswers.generated'

const { questionAnswers } = defineProps<{
  questionAnswers: CalendarBookingViewQuestionAnswersBookingFragment['questionAnswers']
}>()
</script>
<template>
  <div v-if="questionAnswers.length > 0" :class="$style.questionAnswers">
    <div :class="$style.questionAnswers__title">質問への回答</div>
    <dl :class="$style.questionAnswers__inner">
      <div
        v-for="(answer, index) in questionAnswers"
        :key="index"
        :class="$style.questionAnswer"
      >
        <dt :class="$style.questionAnswer__question">
          {{ answer.questionText }}:
        </dt>
        <dd
          :class="{
            [$style['questionAnswer__answer']]: true,
            [$style['questionAnswer__answer--unanswered']]: !answer.answer,
          }"
        >
          {{ answer.answer }}
        </dd>
      </div>
    </dl>
  </div>
</template>
<style lang="scss" module>
.questionAnswers {
  &__title {
    font-weight: bold;
  }

  &__inner {
    padding: 8px;
    background-color: $color-surface-secondary;
    border-radius: $border-radius-inner;
    display: flex;
    flex-direction: column;
  }
}

.questionAnswer {
  display: inline-flex;
  flex-wrap: wrap;
  column-gap: 8px;

  &__question {
    font-weight: bold;
  }

  &__answer {
    white-space: pre-wrap;
    text-wrap: wrap;

    &--unanswered {
      color: $color-text-and-object-disable;

      &::after {
        content: '(回答なし)';
      }
    }
  }
}
</style>
